<script setup lang="ts">

import BaseCard from "@/core/components/base/BaseCard.vue";
</script>

<template>
  <BaseCard class="bg-white p-4">
    <slot />
  </BaseCard>
</template>

<style scoped>

</style>
